export const usePageWrapper = () => {
  return {};
};
